import {
  EnumHorarioFuncionamentoUtil,
  EnumTipoTecnologia,
} from '../../../../../types/enum/User';

export const options_horario_funcionamento = [
  {
    label: 'Horário comercial',
    value: EnumHorarioFuncionamentoUtil.HORARIO_COMERCIAL,
  },
  { label: '24 horas', value: EnumHorarioFuncionamentoUtil.VIGILANCIA_24H },
  { label: 'Manhã', value: EnumHorarioFuncionamentoUtil.MANHA },
  { label: 'Tarde', value: EnumHorarioFuncionamentoUtil.TARDE },
  { label: 'Noite', value: EnumHorarioFuncionamentoUtil.NOITE },
  { label: 'Outros', value: EnumHorarioFuncionamentoUtil.OUTROS },
  { label: 'Madrugada', value: EnumHorarioFuncionamentoUtil.MADRUGADA },
  { label: 'Seg a sex', value: EnumHorarioFuncionamentoUtil.SEG_A_SEX },
  {
    label: 'Seg a Sex - 08:00 às 18:00',
    value: EnumHorarioFuncionamentoUtil.SEG_A_SEX_08_00_AS_18_00,
  },
  {
    label: '08:00 as 12:00 / 13:00 as 18:00',
    value: EnumHorarioFuncionamentoUtil.OITO_AS_DOZE_TREZE_AS_DEZOITO,
  },
  {
    label: '08:00 as 12:00 / 14:00 as 18:00',
    value: EnumHorarioFuncionamentoUtil.OITO_AS_DOZE_CATORZE_AS_DEZOITO,
  },
  {
    label: 'Seg a Sex - 09:00 as 17:00',
    value: EnumHorarioFuncionamentoUtil.SEG_A_SEX_09_00_AS_17_00,
  },
  {
    label: '09:00 as 12:00 / 13:00 as 17:00',
    value: EnumHorarioFuncionamentoUtil.NOVE_AS_DOZE_TREZE_AS_DEZESSETE,
  },
  {
    label: 'Seg a Sab - 09:00 as 18:00',
    value: EnumHorarioFuncionamentoUtil.SEG_A_SAB_09_00_AS_18_00,
  },
  {
    label: '09:00 as 12:00 / 13:00 as 18:00',
    value: EnumHorarioFuncionamentoUtil.NOVE_AS_DOZE_TREZE_AS_DEZOITO,
  },
  {
    label: 'Seg a Sex - após as 18:00',
    value: EnumHorarioFuncionamentoUtil.SEG_A_SEX_APOS_AS_18_00,
  },
];

export const options_tipo_tecnologia = [
  {
    label: 'Web',
    value: EnumTipoTecnologia.WEB,
  },
  {
    label: 'Tef',
    value: EnumTipoTecnologia.TEF,
  }
];
